import React, { useEffect } from "react";
import { Phone, Calendar } from "lucide-react";

// Import your components here
import Header from "./HeaderComponent";
import HeroSection from "./HeroSection";
import Footer from "./Footer";
import ContactSection from "./ContactSection";
import PriestSection from "./PriestSection";
import TrustIndicatorsSection from "./TrustIndicatorsSection";
import ScrollingTextBanner from "./ScrollingTextBanner";
import EventsSection from "./EventsSection";
import { useNavigate } from "react-router-dom";

const MainLandingPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // eslint-disable-next-line no-undef
    fbq("track", "PageView");
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 via-white to-red-50">
      {/* <ScrollingTextBanner text="Main Idol Darshan to Remain Closed on August 11 & 12 August for Restoration Work at Shri Ambabai / Mahalaxmi Temple." /> */}
      <Header />
      {/* Add the scrolling banner here */}
      <HeroSection />
      <EventsSection />
      <PriestSection />
      <TrustIndicatorsSection />
      <ContactSection />
      <Footer />
      {/* Floating Action Buttons */}
      <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 space-y-2 sm:space-y-3">
        <button
          className="bg-blue-500/80 backdrop-blur-sm text-white p-3 sm:p-4 rounded-full shadow-lg hover:bg-blue-600/90 transition-all transform hover:scale-110 active:scale-95"
          onClick={() => window.open("tel:+919699588995", "_self")}
        >
          <Phone className="h-5 w-5 sm:h-6 sm:w-6" />
        </button>

        <button
          onClick={() => navigate("/services")}
          className="bg-gradient-to-r from-orange-500/80 to-red-500/80 backdrop-blur-sm text-white p-3 sm:p-4 rounded-full shadow-lg hover:from-orange-600/90 hover:to-red-600/90 transition-all transform hover:scale-110 active:scale-95"
        >
          <Calendar className="h-5 w-5 sm:h-6 sm:w-6" />
        </button>
      </div>
    </div>
  );
};

export default MainLandingPage;
